import EventHandler from '../../../utils/dom/event-handler';
import { Events } from '../../../utils/dom/html-events';
import SelectorEngine from '../../../utils/dom/selector-engine';
import Request, { ApiMode } from '../../../utils/request';
import Modal from '../../../components/Modal';
import FormGenerator, { FormTypes } from '../../../components/FormGenerator';
import { startLoadingAnimation, stopLoadingAnimation } from '../../../utils/dom/loading';
import { ClassNames } from '../../../utils/dom/css-classes';

const SELECTOR_WRAPPER = '.p-coaches-onboarding';
const SELECTOR_MODAL = '#js-coaches-onboarding-modal';

const SELECTOR_SPLASH = '.p-coaches-onboarding-splash-bg';
const SELECTOR_SPLASH_NEXT = '.p-coaches-onboarding-splash-next';

const SELECTOR_EXIT_BUTTON = '.js-exit-coaches-onboarding';
const SELECTOR_EXIT_CONFIRM_MODAL = '.js-exit-coaches-onboarding-confirm';
const SELECTOR_EXIT_CONFIRM_YES = '.js-exit-coaches-onboarding-confirm-yes';
const SELECTOR_EXIT_CONFIRM_NO = '.js-exit-coaches-onboarding-confirm-no';

const SELECTOR_SUCCESS = '.p-coaches-onboarding-success';
const SELECTOR_SUCCESS_BUTTON = '.p-coaches-onboarding-success--button';

const ERROR_SELECTOR = '.p-coaches-onboarding-error-container';

const SELECTOR_STEP = '.p-coaches-onboarding-step';
const SELECTOR_QUESTION = '.p-coaches-onboarding-questions';
const SELECTOR_STEP_NEXT = '.p-coaches-onboarding-step-next';
const ADDRESS_SEARCH_FIND_SUGGEST = '.lta-address-search--find-suggest';
const ADDRESS_SEARCH_RESULT = '.lta-address-search--result';
const LOCATION_CARD_SEARCH = '.lta-location-card--content';
const SELECTOR_HOUSE_INPUT = 'houseNumber';


const KEY_OBJECT = 'fieldName';
const VALUE_OBJECT = 'value';

const CLICK_EVENT = 'click';
const HIDDEN_CLASS = 'u-hidden';

const IS_LOCAL = false;
class CoachesOnboarding {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		this.formElementsList = {};
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	get stepsData() {
		return this._stepsData;
	}

	set stepsData(_stepsData) {
		this._stepsData = _stepsData;
		if (_stepsData?.length > 0) {
			this.initiateFormGenerator(_stepsData);
		}
	}

	init() {
		this.coachesOnboardingModalElement = SelectorEngine.findOne(SELECTOR_MODAL, this._wrapper);
		this.coachesOnboardingSplash = SelectorEngine.findOne(SELECTOR_SPLASH, this._wrapper);
		this.coachesOnboardingSplashNext = SelectorEngine.findOne(SELECTOR_SPLASH_NEXT, this.coachesOnboardingSplash);

		this.coachesOnboardingStep = SelectorEngine.findOne(SELECTOR_STEP, this._wrapper);
		this.coachesOnboardingQuestion = SelectorEngine.findOne(SELECTOR_QUESTION, this.coachesOnboardingStep);
		this.coachesOnboardingStepNext = SelectorEngine.findOne(SELECTOR_STEP_NEXT, this.coachesOnboardingStep);

		this.exitButton = SelectorEngine.findOne(SELECTOR_EXIT_BUTTON, this._wrapper);
		const exitConfirmModalHtml = SelectorEngine.findOne(SELECTOR_EXIT_CONFIRM_MODAL, this._wrapper);
		this.exitConfirmModal = new Modal(exitConfirmModalHtml, { backdrop: 'static' });

		this.exitConfirmYes = SelectorEngine.findOne(SELECTOR_EXIT_CONFIRM_YES, this._wrapper);
		this.exitConfirmNo = SelectorEngine.findOne(SELECTOR_EXIT_CONFIRM_NO, this._wrapper);

		this.coachesOnboardingSuccess = SelectorEngine.findOne(SELECTOR_SUCCESS, this._wrapper);
		this.coachesOnboardingSuccessButton = SelectorEngine.findOne(
			SELECTOR_SUCCESS_BUTTON,
			this.coachesOnboardingSuccess
		);

		this.errorContainer = SelectorEngine.findOne(ERROR_SELECTOR, this._wrapper);
		this.errorText = SelectorEngine.findOne('.error-text', this.errorContainer);
		this.closeErrorSnackBar = SelectorEngine.findOne('.js-dismiss-error', this.errorContainer);

		this.closeErrorSnackBar.addEventListener(CLICK_EVENT, () => {
			this.errorContainer.classList.add(HIDDEN_CLASS);
			window.location.reload();
		});

		this.coachesOnboardingModal = new Modal(this.coachesOnboardingModalElement, { backdrop: 'static' });
		this.coachesOnboardingModal.isEscapeEventEnable = false;

		this.coachesOnboardingModal.show();

		EventHandler.on(this.coachesOnboardingSplashNext, CLICK_EVENT, () => {
			this.fetchcoachesOnboardingSteps();
		});

		EventHandler.on(this.coachesOnboardingSuccessButton, CLICK_EVENT, () => {
			// NOTE - Commenting this line to prevent background page to be visible.
			// this.coachesOnboardingModal.hide(); 
		});

		this.initEventHandlers();
	}

	initEventHandlers() {
		EventHandler.on(this.exitButton, Events.Click, () => {
			this.exitConfirmModal.show();
		});
		EventHandler.on(this.exitConfirmYes, Events.Click, () => {
			this.handleModalExit();
		});
		EventHandler.on(this.exitConfirmNo, Events.Click, () => {
			this.exitConfirmModal.hide();
		});
	}

	showSuccessPage() {
		this.coachesOnboardingStep.classList.add(HIDDEN_CLASS);
		this.coachesOnboardingSuccess.classList.remove(HIDDEN_CLASS);
	}

	// TODO: Verify and modify a logic for below function
	// showErrorContainer(message) {
	// 	this.coachesOnboardingStep.classList.remove(HIDDEN_CLASS);
	// 	this.errorContainer.classList.remove(HIDDEN_CLASS);
	// 	this.errorText.innerHTML = message;
	// 	this.errorContainer.scrollIntoView();
	// }

	initiateFormGenerator(stepsData) {
		this.coachesOnboardingSplash.classList.add(HIDDEN_CLASS);
		this.coachesOnboardingStep.classList.remove(HIDDEN_CLASS);

		this.formGenerator = new FormGenerator(this.coachesOnboardingQuestion, {
			questions: stepsData,
			totalSteps: 2,
			hasSeparator: true,
			formType: FormTypes.StepForm,
			themeColor: 'color-lta-accent-bright-blue',
			submitButton : {
				title: 'Submit'
			},
			isBackButtonEnabled: true,
			isExitButtonEnabled: true,
			saveAddress: false,
			exitButtonHandler: () => {
				this.exitConfirmModal.show();
			},
			backButtonHandlerFirstStep: () => {
				this.coachesOnboardingSplash.classList.remove(HIDDEN_CLASS);
				this.coachesOnboardingStep.classList.add(HIDDEN_CLASS);
			}
		});
		this.formGenerator.onChange((answers) => {
			this.coachesOnboardingStep.classList.add(HIDDEN_CLASS);
			this.prepareRequestObject(answers);
			this.savecoachesOnboardingSteps(this.answerList);
		});
		this.exitButton.classList.add(HIDDEN_CLASS);
	}
	prepareRequestObject(stepsAnswers) {
		this.answerList = {};
		for (const stepKey in stepsAnswers) {
			const stepAnswersObjects = stepsAnswers[stepKey];
			for (const questionKey in stepAnswersObjects) {
				const answerObject = stepAnswersObjects[questionKey];
				const formatObject = {};
				formatObject[answerObject[KEY_OBJECT]] = answerObject[VALUE_OBJECT];
				this.answerList = {
					source: ['LTA Coaches'],
					...this.answerList,
					...formatObject
				};
			}
		}
	}
	async fetchcoachesOnboardingSteps() {
		try {
			const url = '/api/coachdetails/steps';
			const response = await Request.get(
				url,
				{},
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);
			const { Steps, error } = response;
			if (Steps) {
				this.stepsData = Steps;
				this.getCoachOnboardingAddress();
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}

	prefilledData(address) {
		if (address.address !== undefined) {
			this.addAddress(address.address, true);
		}
	}

	addAddress(address, existing = false, isFocus = true) {
		const autoView = SelectorEngine.findOne(ADDRESS_SEARCH_FIND_SUGGEST, this.step);
		const addressSummary = SelectorEngine.findOne(ADDRESS_SEARCH_RESULT, this.step);
		const addressWrapper = SelectorEngine.findOne(LOCATION_CARD_SEARCH, addressSummary);
		addressWrapper.textContent = '';

		const p = document.createElement('p');
		p.classList.add('u-body2');
		const streetEle = document.createTextNode(address.addressLine1);
		const cityEle = document.createTextNode(address.addressLine2);
		const stateEle = document.createTextNode(address.town);
		const postcodeEle = document.createTextNode(address.postcode);
		const countryEle = document.createTextNode('United Kingdom');

		p.append(streetEle);
		p.append(document.createElement('br'));
		p.append(cityEle);
		if (address.state !== '') {
			p.append(document.createElement('br'));
			p.append(stateEle);
		}
		p.append(document.createElement('br'));
		p.append(postcodeEle);
		if (!address.country || address.country !== '') {
			p.append(document.createElement('br'));
			p.append(countryEle);
		}

		addressWrapper.append(p);

		const hiddenInput = (name, value = '') => {
			const input = document.createElement('input');
			input.setAttribute('type', 'text');
			input.classList.add(ClassNames.Hidden);
			input.setAttribute('name', name);
			input.setAttribute('value', value);
			return input;
		};

		const streetInput = hiddenInput('street', address.addressLine1);
		const cityInput = hiddenInput('city', address.addressLine2);
		const stateInput = hiddenInput('state', address.town);
		const postCodeInput = hiddenInput('postCode', address.postcode);
		const countryInput = hiddenInput('country', 'United Kingdom');

		addressWrapper.append(streetInput);
		addressWrapper.append(cityInput);
		addressWrapper.append(stateInput);
		addressWrapper.append(postCodeInput);
		addressWrapper.append(countryInput);

		const formEvent = new CustomEvent('change', {
			bubbles: true,
			detail: { name: 'address', values: address, existing }
		});

		streetInput.dispatchEvent(formEvent);

		const isAddressMissing = !address.postcode && !address.addressLine1;

		addressSummary.classList.remove(ClassNames.Hidden);
		autoView.classList.add(ClassNames.Hidden);
		const [firstCta, secondCta] = SelectorEngine.find('button', addressSummary);
		if (isAddressMissing && secondCta) {
			secondCta.click();
			const input = SelectorEngine.findOne(SELECTOR_HOUSE_INPUT, this._element);
			if (isFocus) input.focus();
		} else {
			if (isFocus) {
				firstCta.focus();
			}
		}
	}

	async getCoachOnboardingAddress() {
		try {
			// TODO CSA: this endpoint has not been confirmed yet
			const url = '/api/coachdetails/getCoachOnboardingAddress'; // TODO CSA: this endpoint has not been confirmed ye
			let data = await Request.get(
				url,
				{},
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);
			const response = data;
			if (response) {
				this.prefilledData(response);
			}
		} catch (error) {
			console.log('error', error);

			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}

	async savecoachesOnboardingSteps(requestObject) {
		startLoadingAnimation();
		try {
			const url = '/api/coachdetails/SaveCoachOnboardingDetails';
			const response = await Request.post(url, requestObject, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
				}
			});
			const { Success, error } = response;
			stopLoadingAnimation();
			if (Success) {
				this.showSuccessPage();
			} // TODO: Error handling part based on response structure
			// else {
			// 	this.showErrorContainer("error");
			// }

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			stopLoadingAnimation();
			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}

	handleModalExit() {
		// Go back to the page that launched the modal
		history.back();
	}
}

const globalCoachesOnboarding = new CoachesOnboarding();
export default globalCoachesOnboarding;
